import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactNode, useContext } from 'react';

import Container from './container';
import SubCategoryContext from './SubCategoryContext';

interface Props {
    children?: ReactNode;
    value: string;
}

function SubCategory({ children, value: localValue }:Props) {
    const { value, setValue, isColorful } = useContext(SubCategoryContext);
    const isActive = localValue === value;
    return (
        <Button isActive={isActive}
            isColorful={isColorful}
            type='button'
            onClick={() => setValue(localValue)} >
            {children}
        </Button>
    );
}

const Button = styled.button<{
    isActive: boolean;
    isColorful?: boolean;
}>`
    background-color: var(--color-white);
    border: 1px solid var(--color-gray2);
    border-radius: 12px;
    box-shadow: 0 0 2px 2px rgba(205, 205, 205, 0.70);
    font-size: 14px;
    line-height: 20px;
    padding: 8px;
    color: var(--color-gray6);
    white-space: nowrap;
    ${({ isActive }) => isActive && css`
        font-weight: bold;
    `}
    ${({ isActive, isColorful }) => (isActive && isColorful) && css`
        background-color: var(--color-primary);
        color: var(--color-white);
    `}
`;

SubCategory.Container = Container;

export default SubCategory;
